import React, { useCallback, useState } from "react";
import {Button, Modal, Tooltip} from "antd";
import Form from "../forms/CreateDeclarant";
import {MODAL} from "../../constants/translates";
import { Option } from "../common/forms/Interfaces";
import {EditOutlined} from "@ant-design/icons";
import {DeepPartial} from "../../models/Common";
import {Declarant} from "../../models/Declarant";
import ee from "../../services/EventEmitter";
import {UPDATE_DECLARANT_EVENT} from "../../constants/events";

interface Props {
  clients: Option[];
  noClient?: Option;
  departments: Option[];
  entity: DeepPartial<Declarant>;
}
const EditDeclarant: React.FC<Props> = ({
  clients,
  noClient,
  departments,
  entity,
}) => {
  const [modalVisibility, setModalVisibility] = useState<boolean>(false);

  const onToggleModalHandler = useCallback(() => {
    setModalVisibility(!modalVisibility);
  }, [modalVisibility]);

  const onCancelHandler = useCallback(() => {
    setModalVisibility(false);
  }, []);

  const onEditHandler = useCallback((values: DeepPartial<Declarant>) => {
    Modal.confirm({
      title: MODAL.confirm_title,
      content: MODAL.confirm_save,
      onOk: () => {
        console.log('emitting update event', values);
        ee.emit(UPDATE_DECLARANT_EVENT, {...values, id: entity.id});
      },
    });
  }, []);

  return (
    <>
      <Tooltip
        title={'Edit declarant'}
      >
        <div>
          <Button className={'icon-button'} type="primary" onClick={onToggleModalHandler}>
            <EditOutlined />
          </Button>
        </div>
      </Tooltip>
      <Modal
        visible={modalVisibility}
        onCancel={onCancelHandler}
        footer={null}
      >
        <Form
          onFinish={onCancelHandler}
          edit
          defaultValues={entity}
          onEdit={onEditHandler}
          clients={clients}
          noClient={noClient}
          departments={departments}
        />
      </Modal>
    </>
  );
};

export default EditDeclarant;
